export default {"src":"/_next/static/image/public/images/ic_ellipse.c926a8ed7ac3164c8437d80b6178f818.svg","height":6,"width":6};